// extracted by mini-css-extract-plugin
module.exports = {"textAlign":"FontConfig_textAlign__2CZUT","fontWeight":"FontConfig_fontWeight__1Xux3"};